fx.ns("creators", class IACreator extends fx.EventDispatcher {

    constructor(data)
	{
        super();

		this.data = data;

        this._creating = false;
        this._created = false;
        this._previousNumPhotos = 0;

        this._onBackgroundLoadedHandler =  this._onBackgroundLoaded.bind(this);
        this._onBackgroundErrorHandler = this._onBackgroundError.bind(this);

        this._dominantColors = ["#575757"];
        this._lightDominantColors = ["#ffffff"];
        this._bookFont = "Open Sans";
        
        this.on("event", this._onDataEvent, this.data );
    }

    get hasEnougthPhotos()
    {
        return this.data.photos.available.length >= 24;
    }

    _onPhotosProcessed()
    {
        this._bookCreated();
    }

    _getNextDominantColor()
    {
        if (!this._nextDominantColorIndex || this._nextDominantColorIndex >= this._dominantColors.length)
            this._nextDominantColorIndex = 0;

        return this._dominantColors[this._nextDominantColorIndex++];
    }

    _getNextLightDominantColor()
    {
        if (!this._nextLightDominantColorIndex || this._nextLightDominantColorIndex >= this._lightDominantColors.length)
            this._nextLightDominantColorIndex = 0;

        return this._lightDominantColors[this._nextLightDominantColorIndex++];
    }
       
    createBook(story)
    {
        this.data.book.placing = true;
       
        this._creating = true;

        this._story = new models.Story(story, this.data.photos);
        
        // 1 - get theme
        this._themetag = this.data.themetags.getThemeTagFromStr(this._story.eventDescription);

        this.data.themes.load(this._themetag, true, fx.currentLang());
    }

    _onDataEvent(event)
    {
        if (!this._creating) return;
        let e = event.detail.event;

        switch(e.type)
        {
            case "themes-loaded":
                this._createCover();
                break;

            case "connection-error" : // themes not loaded
                this.popup(new shared.popups.ServerError(e.model));
                break;

            case "theme-layouts-loaded":
                this._layoutLoaded();
                break;

            case "theme-layouts-error" :
                this.popup(new shared.popups.ServerError(e.model));
                break;

            case "layout-medias-loaded":
            case "load-layout-medias-error" :
                this._mediasLoaded();
                break;
        }
    }

    _createCover()
    {
        this.data.theme = this.data.themes.getFirst(this._themetag);
        this.data.book.themeid = this.data.theme.id;

        this.data.layouts.loadThemeLayouts(this.data, this.data.theme.id, true);
    }

    _layoutLoaded()
    {
        this.data.book.cover.removeAllContent();

        this._frontCoverLayout = this.data.layouts.frontCoverLayout(this.data.book.themeid);
        // end cover should contain only background
        let frontBackground = this._frontCoverLayout.getBackground("right");
        this._endCoverLayout = new models.ThemeLayout({themeid : 0});
        let background = new models.ThemeLayoutComponent(frontBackground.JSON);
        background.creation = "left";
        this._endCoverLayout.components.addItem(background);

        this._loadMedias( [ this._frontCoverLayout, this._endCoverLayout]);
    }

    _mediasLoaded()
    {
        this.data.book.cover.applyLayout( this._frontCoverLayout, this.data.book.pageWidth + this.data.book.sliceWidth, this.data.book.pageHeight, this.data.book.sliceWidth, "right");
        this.data.book.cover.applyLayout( this._endCoverLayout, this.data.book.pageWidth, this.data.book.pageHeight, this.data.book.sliceWidth, "left");

        let backgrounds = this.data.book.cover.getBackgrounds();

        for(let i = 0 ; i < backgrounds.length; i++)
            backgrounds.getItemAt(i).align = "";
      
        let photos = [this._story.coverPhoto].concat( this._story.photos );
        
        this._updatePhotos(this.data.book.cover, "right", photos, 0)
       
        // get front font family
        this._getCoverFontFamily();
 
        // try to get dominant colors
        let rightBackground = backgrounds.find({creation : "right"});
        if (rightBackground)
            this._analyseBackgroundColors(rightBackground);
        else
            this._createPages();

    }

    _getCoverFontFamily()
    {
        let textComponents = this.data.book.cover.getComponents("right", this.data.book.pageWidth, this.data.book.sliceWidth).filter(component => component.component_type == "text");
        if (textComponents.length > 0)
        {
            textComponents.sort((a, b) => a.width * b.height - b.width * a.height);
            var div = document.createElement("div");
            div.innerHTML = textComponents.getItemAt(0).content;
            var fonts = Utils.getCssPropertyValues(div, "fontFamily");
            fonts = fonts.filter((font) => font != "Open Sans");
            if (fonts.length > 0)
                this._bookFont = fonts.getItemAt(0);
        }
        
    }

    _analyseBackgroundColors(bgComponent)
    {
        let background = this.data.backgrounds.find({id : bgComponent.content});
        if (background)
        {
            let img = new Image(); 
            img.onload = this._onBackgroundLoadedHandler;
            img.onerror = this._onBackgroundErrorHandler;
            img.src = background.thumb;
        }
        else
            this._createPages();
    }

    _onBackgroundLoaded(e)
    {
        const colorThief = new ColorThief();
        let colors = colorThief.getPalette(e.target);
        let hexColors = [];
        for (let i = 0; i < colors.length; i++)
        {
            let color = tinycolor({ r : colors[i][0], g : colors[i][1], b : colors[i][2]});
            hexColors.push("#" + color.toHex());
        }

        this._dominantColors = hexColors.slice(0, 5);
        this._lightDominantColors = this._dominantColors.map((color) => tinycolor(color).setAlpha(0.5).toRgbString());
        
        this._createPages();
    }

    _onBackgroundError()
    {
        this._createPages();
    }

    _createPages()
    {
        // remove all content from pages
        for (let i = 0; i < this.data.book.innerPages.length; i++)
            this.data.book.innerPages.getItemAt(i).removeAllContent();

        // TODO : keep only 24 pages

        if (this.data.photos.length <= 24 /*|| this._story.numPossiblePages <= 20*/)
            this._createSimplePageBook(); // we don't use story, one picture per page
        else
            //this._createStoryBook(); // we use story
            this._createStoryBookWithLabels();

        this._bookCreated();
    }

    _createSimplePageBook()
    {
        let pageIndex = 0, side = "right";
        for (let i = 0; i < this.data.photos.length; i++)
        {
            let currentPage = this.data.book.innerPages.getItemAt(pageIndex);
            let photo = this.data.photos.getItemAt(i);

            let layout = fx.service("LayoutsGenerator").getLayouts([photo])[0];
     
            currentPage.applyLayout(layout, this.data.book.pageWidth, this.data.book.pageHeight,0, side);
            
            let photoComponent = currentPage.getComponents(side, this.data.book.pageWidth, 0).filter(component => component.component_type == "photo")[0];
            
            photoComponent.update({content : photo.id, effectName : photo.needBrightness ? 2 : 1, width_inner : 0});
         
            if (side == "right")
            {
                side = "left";
                pageIndex++;
            }
            else
                side = "right";

            if (pageIndex == this.data.book.innerPages.length -1 )
            {
                if (i >= this.data.photos.length - 2) // last page & last group of pictures, we don't add a page
                    continue;

                let page = this.data.book.addPage(this.data.book.innerPages.getItemAt(pageIndex), "right", true, true, this.data.layouts);
                page.removeAllContent();
            }

          
        }
    }

    _createStoryBookWithLabels()
    {
        let currentPage, groups = this._story.possibleGroups;
        for (let i = 0; i < groups.length; i++)
        {
            let group = groups[i];

            currentPage = this._getNextPage(currentPage);
            
            if (i == 0) // first page
            {
                if (group.photos.length == 1 || !group.label)
                {
                    // one picture
                    let layout = fx.service("LayoutsGenerator").getLayouts(group.photos)[0];

                    currentPage.applyLayout(layout, this.data.book.pageWidth, this.data.book.pageHeight,0, "right");

                    this._updatePhotos(currentPage, "right", group.photos, 0);
                }
                else
                {
                    // label first page
                    this._addText(group.label, currentPage, "right");

                    currentPage = this._getNextPage(currentPage);
                    
                    let half = group.photos.length / 2;
                    let numberLeft = Math.round(half)
                    
                    let leftPhotos = group.photos.slice(0, numberLeft );
                    let rightPhotos = group.photos.slice(numberLeft);
                    let sameConf = fx.service("LayoutsGenerator").getCode(leftPhotos) == fx.service("LayoutsGenerator").getCode(rightPhotos);
                    let layoutsLeft = fx.service("LayoutsGenerator").getLayouts( leftPhotos );
                    let layoutsRight = fx.service("LayoutsGenerator").getLayouts( rightPhotos );

                    let layoutLeft = layoutsLeft[0];
                    let layoutRight = layoutsRight[sameConf && leftPhotos.length > 3 && layoutsRight.length > 1 ? 1 : 0 ];

                    currentPage.applyLayout(layoutLeft, this.data.book.pageWidth, this.data.book.pageHeight,0, "left");
                    currentPage.applyLayout(layoutRight, this.data.book.pageWidth, this.data.book.pageHeight,0, "right");

                    this._updatePhotos(currentPage, "left", group.photos, 0);
                    this._updatePhotos(currentPage, "right", group.photos, numberLeft);
                }

                this._changeBgColor(currentPage);
            }
            else
            {
                if (group.label)
                {
                    this._addText(group.label, currentPage, "left");

                    let photos = group.photos;
                    let numberPhotos = photos.length;
                    
                    if(group.photos.length > 3)
                    {
                        numberPhotos = Math.round(photos.length / 3);
                        photos = photos.slice(0, numberPhotos);
                    }
                    
                    let layoutRight = fx.service("LayoutsGenerator").getLayouts(photos)[0];
                    currentPage.applyLayout(layoutRight, this.data.book.pageWidth, this.data.book.pageHeight,0, "right");


                    this._updatePhotos(currentPage, "right", photos, 0);

                    // change bg color
                    this._changeBgColor(currentPage, "right");

                    if(group.photos.length > 3)
                    {
                        currentPage = this._getNextPage(currentPage);

                        // change bg color
                        this._changeBgColor(currentPage);
                        
                        let leftPhotos = group.photos.slice(numberPhotos, 2*numberPhotos);
                        let rightPhotos = group.photos.slice(numberPhotos*2);
                        let sameConf = fx.service("LayoutsGenerator").getCode(leftPhotos) == fx.service("LayoutsGenerator").getCode(rightPhotos);
                        let layoutsLeft = fx.service("LayoutsGenerator").getLayouts( leftPhotos );
                        let layoutsRight = fx.service("LayoutsGenerator").getLayouts(rightPhotos );

                        let layoutLeft = layoutsLeft[0];
                        let layoutRight = layoutsRight[sameConf && leftPhotos.length > 3 && layoutsRight.length > 1 ? 1 : 0 ];

                        currentPage.applyLayout(layoutLeft, this.data.book.pageWidth, this.data.book.pageHeight,0, "left");
                        currentPage.applyLayout(layoutRight, this.data.book.pageWidth, this.data.book.pageHeight,0, "right");

                        this._updatePhotos(currentPage, "left", group.photos, numberPhotos);

                        this._updatePhotos(currentPage, "right", group.photos, 2*numberPhotos);
                    }
                }
                else
                {
                    if (group.photos.length == 1)
                    {
                        // one picture
                        let layout = fx.service("LayoutsGenerator").getLayouts(group.photos)[0];
    
                        currentPage.applyLayout(layout, this.data.book.pageWidth, this.data.book.pageHeight,0, "left");

                        // change bg color
                        this._changeBgColor(currentPage, "left");
    
                        this._updatePhotos(currentPage, "left", group.photos, 0);
                    }
                    else
                    {
                        let half = group.photos.length / 2;
                        let numberLeft = Math.round(half)

                        let leftPhotos = group.photos.slice(0, numberLeft );
                        let rightPhotos = group.photos.slice(numberLeft);
                        let sameConf = fx.service("LayoutsGenerator").getCode(leftPhotos) == fx.service("LayoutsGenerator").getCode(rightPhotos);
                        let layoutsLeft = fx.service("LayoutsGenerator").getLayouts(leftPhotos);
                        let layoutsRight = fx.service("LayoutsGenerator").getLayouts(rightPhotos);

                        let layoutLeft = layoutsLeft[0];
                        let layoutRight = layoutsRight[sameConf && leftPhotos.length > 3 && layoutsRight.length > 1 ? 1 : 0 ];

                        currentPage.applyLayout(layoutLeft, this.data.book.pageWidth, this.data.book.pageHeight,0, "left");
                        currentPage.applyLayout(layoutRight, this.data.book.pageWidth, this.data.book.pageHeight,0, "right");

                        // change bg color
                        this._changeBgColor(currentPage);

                        this._updatePhotos(currentPage, "left", group.photos, 0);
                        this._updatePhotos(currentPage, "right", group.photos, numberLeft);
                    }
                }
              
            }
        }
    }

    _changeBgColor(page, side)
    {
        if (!this._changeIndex)
            this._changeIndex = 0;

        this._changeIndex++;

        if (this._changeIndex % 3 == 0)
        {
            let background = page.getComponents(side || (this._changeIndex % 6 == 0 ? "left" : "right"), this.data.book.pageWidth, 0).filter(component => component.component_type == "background")[0];
            background.content = "";
            background.bgcolor = this._getNextLightDominantColor();
        }
    }

    _updatePhotos(page, side, photos, index)
    {
        let photoComponents = page.getComponents(side, this.data.book.pageWidth, 0).filter(component => component.component_type == "photo");
        photoComponents = photoComponents.sort((a,b) => a.width/a.height - b.width/b.height);

        let currentPhotos = photos.slice(index, index + photoComponents.length);
        currentPhotos = currentPhotos.sort((a,b) => a.width/a.height - b.width/b.height);

        for(let j = 0; j < photoComponents.length && currentPhotos.getItemAt(j); j++)
        {
            let photoComponent = photoComponents.getItemAt(j);
            let photo = currentPhotos.getItemAt(j);
            photoComponent.update({content : photo.id, effectName : photo.needBrightness ? 2 : 1, width_inner : 0});
        }
    }

    _getNextPage(currentPage)
    {
        let index = currentPage ? this.data.book.innerPages.indexOf( currentPage ) : -1;
        index++;

        while (index >= this.data.book.innerPages.length -1 /*&& i < groups.length - 2*/)
        {
            //if (i >= groups.length - 2) // last page & last group of pictures, we don't add a page
            //    continue;

            let page = this.data.book.addPage(this.data.book.innerPages.getItemAt(index), "right", true, true, this.data.layouts);
            page.removeAllContent();
        }

        let page = this.data.book.innerPages.getItemAt(index);

        return page;
    }

    _addText(label, page, side)
    {
        // TODO : text au dessus de la shape
        let text = {
            content : "<p style='text-align: center;'><span style='font-size: " + (label.length> 40 ? 7 : 8) + "px;font-family: " + this._bookFont + ";'>" + label + "</span></p>",
            component_type : "text",
            text_color : "#000",
            font_family : "Open Sans",
            width : this.data.book.pageWidth * 0.9,
            height : 35,
            height_inner : -1 // force resize
        }

        page.addComponent(text, side, this.data.book.pageWidth, this.data.book.pageHeight,0, false);

        // TODO : ligne au centre
        let shape = {
            component_type : "shape",
            content : 1,
            width : this.data.book.pageWidth * 0.4,
            height : 2,
            x : (side == "left" ? 0 : this.data.book.pageWidth) + (this.data.book.pageWidth * 0.6)/2,
            y :  this.data.book.pageHeight / 2 + 10,
            bgcolor : this._getNextDominantColor(),
        };

        page.addComponent(shape, side, this.data.book.pageWidth, this.data.book.pageHeight,0, false);
    }

    _createStoryBook()
    {
        let pageIndex = 0, side = "right", groups = this._story.groupPages;
        for (let i = 0; i < groups.length; i++)
        {
            let group = groups[i];

            let currentPage = this.data.book.innerPages.getItemAt(pageIndex);

            let layouts = fx.service("LayoutsGenerator").getLayouts(group.photos);
     
            let layout = layouts.getItemAt(0);
            
            currentPage.applyLayout(layout, this.data.book.pageWidth, this.data.book.pageHeight,0, side);
            
            let photosComponents = currentPage.getComponents(side, this.data.book.pageWidth, 0).filter(component => component.component_type == "photo");
            
            for(let j = 0; j < photosComponents.length; j++)
            {
                let photoComponent = photosComponents.getItemAt(j);
                let photo = group.photos.getItemAt(j);
                photoComponent.update({content : photo.id, effectName : photo.needBrightness ? 2 : 1, width_inner : 0});
            }

            if (side == "right")
            {
                side = "left";
                pageIndex++;
            }
            else
                side = "right";

            if (pageIndex == this.data.book.innerPages.length -1 )
            {
                if (i >= groups.length - 2) // last page & last group of pictures, we don't add a page
                    continue;

                let page = this.data.book.addPage(this.data.book.innerPages.getItemAt(pageIndex), "right", true, true, this.data.layouts);
                page.removeAllContent();
            }
        }
    }

    _bookCreated()
    {
        this.data.book.placing = false;
        this.data.book.deleted = false;
        
        this._created = true;
        this._creating = false;

        this.bookUpdated = false;

        this.data.history.clear();

        this.trigger("ready");
    }



    _loadMedias(layouts)
    {
        let medias = [];
        for (let i = 0; i < layouts.length; i++)
        {
            let layout = layouts.getItemAt(i);
            for(let j = 0; j < layout.components.length; j++)
            {
                let component = layout.components.getItemAt(j);
                if (component.isSticker && component.content && !this.data.stickers.find({id : component.content}) && !medias.find({type : "sticker", id : component.content}))
                    medias.push( {type : "sticker", id : component.content})
                else
                if (component.isBackground && component.content && !this.data.backgrounds.find({id : component.content}) && !medias.find({type : "background", id : component.content}))
                    medias.push( {type : "background", id : component.content})
            }
        }

        if (medias.length == 0)
            this._mediasLoaded();
        else
            this.data.loadLayoutMedias(medias);
    }

   
});